import { render } from "./BarGraph.vue?vue&type=template&id=69d99bdf&scoped=true&ts=true"
import script from "./BarGraph.vue?vue&type=script&lang=ts"
export * from "./BarGraph.vue?vue&type=script&lang=ts"

import "./BarGraph.vue?vue&type=style&index=0&id=69d99bdf&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d99bdf"]])

export default __exports__